export default {
  "content": "<path d=\"M112 112l20 320c.95 18.49 14.4 32 32 32h184c17.67 0 30.87-13.51 32-32l20-320\" class=\"ionicon-fill-none ionicon-stroke-width\"/><path d=\"M80 112h352\" class=\"ionicon-stroke-width\"/><path d=\"M192 112V72a23.93 23.93 0 0124-24h80a23.93 23.93 0 0124 24v40m-64 64v224m-72-224l8 224m136-224l-8 224\" class=\"ionicon-fill-none ionicon-stroke-width\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "class": "ionicon",
    "viewBox": "0 0 512 512"
  }
};